module.exports = __webpack_public_path__ + "static/media/S4N5-1.5a03b724.svg";